import { environment } from "@/plugins/commonImports";
import errorLoggerService from "@/app/errors/errorLoggerService";
import type { ComponentOptions } from "vue";
import type Vue from "vue";
import appStore from "@/store/modules/appStore";

/**
 * Problems with errors being captured within an async function on a watcher, this is a currently known bug:
 * https://github.com/vuejs/vue/issues/10009
 */
export const errorCaptured: ComponentOptions<any>["errorCaptured"] = (
  e: Error,
  v: Vue,
  info: string
) => {
  const vueErrorContext = [info, v?.$vnode?.tag ?? ""]
    .filter((x) => x)
    .join(" -- ");
  appStore.showError(e, vueErrorContext);
  errorLoggerService.logError("Unhandled global error", e, vueErrorContext);

  return environment.isDevelopment; // Suppress errors in production mode
};
